import { useCallback, useEffect } from 'react';
// @mui
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
//
import axios, { endpoints } from 'src/utils/axios';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { IftaFiling } from 'src/models';

// ----------------------------------------------------------------------

// "Current Filing" = the most recent filing that hasn't been paid/submitted.
// The navbar only routes here for direct URL visits: with a current filing we
// jump into its wizard, without one we land back on the filings list (where
// the navbar's "Current Filing" button offers to start one in place).
export default function CurrentFilingPage() {
  const router = useRouter();

  const resolve = useCallback(async () => {
    const response = await axios.get<IftaFiling[]>(endpoints.filings.findAll);
    const current = (response.data || []).find((filing) => filing.paymentStatus !== 'paid');
    router.replace(current ? paths.filings.wizard(current.id) : paths.filings.root);
  }, [router]);

  useEffect(() => {
    resolve();
  }, [resolve]);

  return (
    <Stack alignItems="center" sx={{ py: 10 }}>
      <CircularProgress />
    </Stack>
  );
}
